function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_289",
  "data-name": "Path 289",
  d: "M144,509a4,4,0,0,1,3.988,3.684L146,514.671V513a2,2,0,0,0-4,0v5.671l-1.743,1.743A4,4,0,0,1,140,519v-6A4,4,0,0,1,144,509Zm-1.142,11.641L146,517.5l2-2,5.671-5.672L155,511.157l-7,7-4.769,4.769-1.591,1.591-1.495,1.495-5.816,5.816L133,530.5l5.6-5.6,1.417-1.418,1.416-1.416ZM138,519a5.975,5.975,0,0,0,.756,2.915l-1.457,1.457A7.969,7.969,0,0,1,136,519v-2h2Zm5,7.938a7.985,7.985,0,0,1-.809-.143L143.986,525H144a6.006,6.006,0,0,0,6-6v-.014L151.986,517H152v2a8,8,0,0,1-7,7.938V530h-2Z",
  transform: "translate(-133 -509)",
  fill: "current",
  fillRule: "evenodd"
});

function SvgMicrophoneOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22.828,
    viewBox: "0 0 22 22.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOff);
export default __webpack_public_path__ + "static/media/microphone-off.50fd8290.svg";
export { ForwardRef as ReactComponent };